module.exports = "/assets/5bb04428c77795eb0f4bc16ac83624ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/CZ.png
// module id = 1283
// module chunks = 0